<template>
    <common-dialog v-if="visible" :show="visible" :title="snackbar.title" :icon="snackbar.state == 'error' ? 'fxt-warning'
            : snackbar.state == 'info' ? 'fxt-check'
                : snackbar.state == 'delete' ? 'fxt-trash'
                    : ''" buttonTextConfirm="Ok" @closeDialog="visible = false" @confirmAction="visible = false" layout="Chain">
        <p>{{ snackbar.message }}</p>
    </common-dialog>
</template>
<script>
import { Notification } from '@fixit/fixit-no-header/src/models';
import { CommonDialog } from '@fixit/fixit-no-header/src/components/Common/CommonComponents'


export default {
    name: "fixitno-snackbar",
    props: {
        snackbar: {
            type: [Notification, Object],
            required: true,
        },
    },
    components: {
        CommonDialog
    },
    data() {
        return {
            notificationVisible: false
        };
    },
    computed: {
        visible: {
            get() {
                return this.notificationVisible
            },
            set(value) {
                this.notificationVisible = value
            }
        }
    },
    methods: {
        closeSnackbar() {
            this.$emit("removeSnackbar", null);
        },
    },
    watch: {
        snackbar(a) {
            this.visible = a.visible
            // if (a.visible == true) {
            //   setTimeout(this.closeSnackbar, a.duration);
            // }
        },
    },
    created() {
    }
};
</script>
<style lang="scss">
.fixit-snackbar {
    z-index: 555 !important;
    height: 100vh !important;

    .v-snack__wrapper {
        position: absolute !important;
        bottom: 50px !important;
    }

    &__error {
        .v-snack__wrapper {
            background-image: linear-gradient(var(--v-primary-opacity-12) 100%, var(--v-primary-opacity-12) 100%);
            background-color: white !important;
        }
    }

    &__info {
        .v-snack__wrapper {
            background-image: linear-gradient(var(--v-primary-opacity-12) 100%, var(--v-primary-opacity-12) 100%);
            background-color: white !important;
        }
    }

    &__body {
        &--message {
            &-error {
                color: #222222 !important;
            }

            &-info {
                color: #222222 !important;
            }
        }
    }
}
</style>